<template>
  <b-card header="Payment Process Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body payment_process_info">
    <div v-if="!e_payment_info_process" class="row">
      <div class="col-12">
        <p class="font-weight-bold pt-0 mb-3">Invoicing Settings</p>
      </div>
      <!-- Payroll Solution TODO - should just be Genius not V3 -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="gm_solution">Payroll Solution</label>
        <p id="gm_solution" v-html="return_payroll_solution"></p>
      </div>
      <!-- VAT percentage worked to -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="vat_perc_worked_to">Minimum VAT</label>
        <p id="vat_perc_worked_to" v-html="return_min_vat_worked_to"></p>
      </div>
      <!-- VAT percentage worked to -->
      <div class="col-xl-4 form-group" v-if="isPayrollCrm">
        <label class="form-label" for="pay_trust_account">Pay TRUST ACCOUNT</label>
        <p id="pay_trust_account" v-html="return_pay_trust_account"></p>
      </div>

      <div class="col-12" v-if="hasContractorInvoiceTemplate || hasPayeInvoiceTemplate">


        <div class="row mb-3" v-for="template in company.invoice_settings.templates">
          <div class="col-12">
            <div class="card template_card p-3">
              <div class="row">
                <div class="col-12">
                  <h5 class="bp_color">{{ template.invoice_template }} TEMPLATE</h5>
                </div>
                <div class="col-xl-4">
                  <div>
                    <strong class="template_label">Batch type:</strong><span>{{return_batch_type(template)}}</span>
                  </div>
                  <div>
                    <strong class="template_label">Line type:</strong><span>{{return_line_type(template)}}</span>
                  </div>
                </div>
                <div class="col-xl-4">
                  <div>
                    <strong class="template_label">Additions inclusive:</strong><span>{{return_additions_inclusive(template)}}</span>
                  </div>
                  <div>
                    <strong class="template_label">Margin inclusive:</strong><span>{{return_margin_inclusive(template)}}</span>
                  </div>
                  <div>
                    <strong class="template_label">Reverse VAT applied:</strong><span>{{return_reverse_vat_applies(template)}}</span>
                  </div>
                </div>
                <div class="col-xl-4">
                  <div><strong>Email TO:</strong></div>
                  <div v-for="email in template.email_to">{{email}}</div>
                  <div><strong>Email CC:</strong></div>
                  <div v-for="email in template.email_cc">{{email}}</div>
                </div>
                <div class="col-xl-8 mt-3">
                  <div><strong>Template created/last updated by:</strong></div>
                  <div>{{return_created_last_updated_by(template)}}</div>
                </div>
                <div class="col-xl-4 text-right">
                  <button class="btn orcaBtn blueBtn sm_btn mr-2 mt-3" @click.prevent="edit_invoice_template">Edit</button>
                  <button class="btn orcaBtn danger sm_btn mt-3" @click.prevent="delete_invoice_template(template)"><i class="fas fa-trash-alt"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <h5 class="red_color">No invoice template selected for the company</h5>
      </div>
      <div class="col-12 form-group text-right" v-if="showAddInvoiceTemplateButton">
        <button class="btn orcaBtn sm_btn" @click.prevent="add_invoice_template">Add Invoice Template</button>
      </div>

      <modal_add_invoice_template v-if="$store.state.companies.invoice_templates_modal.add_modal"></modal_add_invoice_template>
      <modal_edit_invoice_template v-if="$store.state.companies.invoice_templates_modal.edit_modal"></modal_edit_invoice_template>


      <!-- Additional Invoice Requirements -->
      <div class="col-12 form-group">
        <label class="form-label" for="invoicing_additional_requirements">Additional Invoice Requirements</label>
        <pre v-if="payment_process_info.additional_invoice_requirements !== null"
             id="invoicing_additional_requirements">{{ payment_process_info.additional_invoice_requirements }}</pre>
        <p v-else>&nbsp;</p>
      </div>

      <div class="col-12">
        <hr class="mt-0 mb-3">
        <p class="font-weight-bold pt-0 mb-3">Instruction/Timesheet submission information and payment to {{ returnCrmCompanyName }} by the company</p>
      </div>
      <!-- Pay Frequency -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="pay_frequency">Pay Frequency</label>
        <p id="pay_frequency" v-html="return_pay_cycle"></p>
      </div>
      <!-- Timesheet Frequency -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="timesheet_frequency">Timesheet Frequency</label>
        <p id="timesheet_frequency" v-html="return_timesheet_cycle"></p>
      </div>
      <!-- Working week start day -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="working_week_end_day">Working week start day</label>
        <p id="working_week_end_day" v-html="return_pay_week_start_day"></p>
      </div>
      <!-- Client Instruction Day -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="client_instruction_day">Client Instruction Day</label>
        <p id="client_instruction_day" v-html="return_pay_instruction_day"></p>
      </div>
      <!-- Client Payment to Genius Day -->
      <div class="col-xl-4 form-group">
        <label class="form-label" for="client_payment_to_gm_day">Client Payment to {{ returnCrmCompanyName }} Day</label>
        <p id="client_payment_to_gm_day" v-html="return_pay_client_payment_day"></p>
      </div>

      <div class="col-12">
        <hr class="mt-0 mb-3">
        <p class="font-weight-bold pt-0 mb-3">Payment Terms</p>
      </div>
      <!-- Require Payment Terms -->
      <div class="col-xl-4 form-group" v-if="isPayrollCrm">
        <label class="form-label" for="require_payroll_payment_terms">Require Payroll Payment Terms</label>
        <p id="require_payroll_payment_terms" v-html="return_payroll_require_payment_terms"></p>
      </div>
      <div class="col-xl-4 form-group" v-if="isRecruitmentCrm">
        <label class="form-label" for="require_recruitment_payment_terms">Require Payment Terms</label>
        <p id="require_recruitment_payment_terms" v-html="return_recruitment_require_payment_terms"></p>
      </div>
      <!-- Payment - Days from Invoice -->
      <div v-if="isPayrollRequirePaymentTerms && isPayrollCrm" class="col-xl-4 form-group">
        <label class="form-label" for="payment_days_from_invoice">Payment Terms - Days from Invoice</label>
        <p id="payment_days_from_invoice" v-html="return_payroll_payment_terms_length"></p>
      </div>
      <div v-if="isRecruitmentRequirePaymentTerms && isRecruitmentCrm" class="col-xl-4 form-group">
        <label class="form-label" for="recruitment_payment_terms_length">Payment Terms - Days from Invoice</label>
        <p id="recruitment_payment_terms_length" v-html="return_recruitment_payment_terms_length"></p>
      </div>
      <!-- Payment - Payment Terms Percentage Fee -->
      <div v-if="isPayrollRequirePaymentTerms && isPayrollCrm" class="col-xl-4 form-group">
        <label class="form-label" for="payment_terms_perc">Payment Terms Percentage Fee</label>
        <p id="payment_terms_perc" v-html="return_payroll_payment_terms_percentage"></p>
      </div>
      <div v-if="isRecruitmentRequirePaymentTerms && isRecruitmentCrm" class="col-xl-4 form-group">
        <label class="form-label" for="recruitment_payment_terms_perc">Payment Terms Percentage Fee</label>
        <p id="recruitment_payment_terms_perc" v-html="return_recruitment_payment_terms_percentage"></p>
      </div>

      <div class="col-12">
        <hr class="mt-0 mb-3">
        <p class="font-weight-bold pt-0 mb-3">PO Number Information</p>
      </div>
      <!-- PO Required -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="po_required">PO Required</label>
        <p id="po_required" v-html="return_po_required"></p>
      </div>
      <!-- PO Details -->
      <div class="col-xl-6 form-group" v-if="payment_process_info.po_required">
        <label class="form-label" for="po_details">PO Details (i.e. what relates to)</label>
        <pre id="po_details">{{ payment_process_info.po_details }}</pre>
      </div>

      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form()" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Payment Information/Process</button>
      </div>
    </div>
    <div v-else-if="e_payment_info_process" class="row">
      <ValidationObserver ref="editPaymentInfoProcessForm" slim tag="div" class="col-12">
        <form role="form" @submit.prevent="submit_form">
          <div class="row">
            <!-- Genius Payroll Solution -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Genius Payroll Solution" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_gm_solution">Payroll Solution</label>
              <multiselect v-model="edit_payment_process_info.payroll_solution" id="edit_gm_solution" name="edit_gm_solution" placeholder=""
                           :options="ms_opts.gm_solution" label="value" track-by="id" @input="select_payroll_solution" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- VAT percentage worked to -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="VAT percentage worked to" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_vat_perc_worked_to">VAT percentage worked to</label>
              <multiselect v-model="edit_payment_process_info.min_vat_percentage_worked_to" id="edit_vat_perc_worked_to" name="edit_vat_perc_worked_to" placeholder=""
                           :options="ms_opts.vat_perc_worked_to" :readonly="disable_min_vat" label="value" track-by="id" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="col-xl-4" v-if="isPayrollCrm">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_pay_trust_account">Pay TRUST ACCOUNT</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_payment_process_info.pay_trust_account" id="edit_pay_trust_account" name="edit_pay_trust_account"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>


            <!-- Additional Invoice Requirements -->
            <div class="col-12 form-group">
              <label class="form-label" for="edit_additional_invoice_requirements">Additional Invoice Requirements</label>
              <textarea type="text" v-model="edit_payment_process_info.additional_invoice_requirements" id="edit_additional_invoice_requirements"
                        name="edit_additional_invoice_requirements" class="form-input" rows="3"></textarea>
            </div>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Pay Frequency -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Pay Frequency to Workers" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_pay_cycle">Pay Frequency to Workers</label>
              <multiselect v-model="edit_payment_process_info.pay_cycle" id="edit_pay_cycle" name="edit_pay_cycle" placeholder=""
                           :options="ms_opts.pay_cycle" label="value" track-by="id" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Timesheet Frequency -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Timesheet Submission Frequency" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_timesheet_cycle">Timesheet Submission Frequency</label>
              <multiselect v-model="edit_payment_process_info.timesheet_cycle" id="edit_timesheet_cycle" name="edit_timesheet_cycle" placeholder=""
                           :options="ms_opts.timesheet_cycle" label="value" track-by="id" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Working week start day -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Working week start day" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_pay_week_start_day">Working week start day</label>
              <multiselect v-model="edit_payment_process_info.pay_week_start_day" id="edit_pay_week_start_day" name="edit_pay_week_start_day" placeholder=""
                           :options="ms_opts.pay_week_start_day" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Client Instruction Day -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Client Instruction Day" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_pay_instruction_day">Client Instruction Day</label>
              <multiselect v-model="edit_payment_process_info.pay_instruction_day" id="edit_pay_instruction_day" name="edit_pay_instruction_day" placeholder=""
                           :options="ms_opts.pay_instruction_day" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Client Payment to Genius Day -->
            <ValidationProvider rules="" v-slot="{errors, classes}" name="Client Payment Day" tag="div" class="col-xl-4 form-group">
              <label class="form-label" for="edit_pay_client_payment_day">Client Payment to {{ returnCrmCompanyName }} Day</label>
              <multiselect v-model="edit_payment_process_info.pay_client_payment_day" id="edit_pay_client_payment_day" name="edit_pay_client_payment_day" placeholder=""
                           :options="ms_opts.pay_client_payment_day" selectLabel=""></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Require Payment Terms -->
            <div class="col-xl-4" v-if="isPayrollCrm">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_payment_terms_payroll">Require Payroll Payment Terms</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_payment_process_info.payroll_require_payment_terms" id="edit_payment_terms_payroll" name="edit_payment_terms_payroll"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div class="col-xl-4" v-if="isRecruitmentCrm">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_payment_terms_recruitment">Require Payment Terms</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_payment_process_info.recruitment_require_payment_terms" id="edit_payment_terms_recruitment"
                                    name="edit_payment_terms_recruitment" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <!-- Payment - Days from Invoice -->
            <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Payment Terms - Days from Invoice" tag="div" class="col-xl-4 form-group"
                                v-if="edit_payment_process_info.payroll_require_payment_terms && isPayrollCrm">
              <label class="form-label" for="edit_payment_terms_length">Payment Terms - Days from Invoice</label>
              <input type="text" v-model="edit_payment_process_info.payroll_payment_terms_length" id="edit_payment_terms_length" name="edit_payment_terms_length"
                     class="form-input" maxlength="255">
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Payment Terms - Days from Invoice" tag="div" class="col-xl-4 form-group"
                                v-if="edit_payment_process_info.recruitment_require_payment_terms && isRecruitmentCrm">
              <label class="form-label" for="edit_recruitment_payment_terms_length">Payment Terms - Days from Invoice</label>
              <input type="text" v-model="edit_payment_process_info.recruitment_payment_terms_length" id="edit_recruitment_payment_terms_length"
                     name="edit_recruitment_payment_terms_length" class="form-input" maxlength="255">
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- Payment - Payment Terms Percentage Fee -->
            <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Payment Terms Percentage Fee" tag="div" class="col-xl-4 form-group"
                                v-if="edit_payment_process_info.payroll_require_payment_terms && isPayrollCrm">
              <label class="form-label" for="edit_payment_terms_perc">Payment Terms Percentage Fee Amount</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                <input type="text" v-model="edit_payment_process_info.payroll_payment_terms_perc" id="edit_payment_terms_perc" name="edit_payment_terms_perc"
                       class="form-input" :class="classes">
              </div>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Payment Terms Percentage Fee" tag="div" class="col-xl-4 form-group"
                                v-if="edit_payment_process_info.recruitment_require_payment_terms && isRecruitmentCrm">
              <label class="form-label" for="edit_recruitment_payment_terms_perc">Payment Terms Percentage Fee Amount</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                <input type="text" v-model="edit_payment_process_info.recruitment_payment_terms_perc" id="edit_recruitment_payment_terms_perc"
                       name="edit_recruitment_payment_terms_perc" class="form-input" :class="classes">
              </div>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- PO Required -->
            <div class="col-xl-6">
              <div class="row">
                <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_po_required">PO Required</label>
                <div class="col-xl-4 form-group">
                  <bootstrap-toggle v-model="edit_payment_process_info.po_required" id="edit_po_required" name="edit_po_required"
                                    :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <!-- PO Details -->
            <div class="col-xl-6 form-group" v-if="edit_payment_process_info.po_required">
              <label class="form-label" for="edit_po_details">PO Details</label>
              <textarea type="text" v-model="edit_payment_process_info.po_details" id="edit_po_details" name="edit_po_details" class="form-input" rows="3"></textarea>
            </div>
          </div>
          <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
          <div class="row mb-3 mt-2">
            <div class="col-xl-6">
              <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
            </div>
            <div class="col-xl-6">
              <button type="submit" class="btn orcaBtn sm_btn w-100">Update payment/process information</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';
// JS arrays
import daysOfWeek from "resources/js/assets/crm_options/days_of_week";
// modals for invoice templates
import modal_add_invoice_template from "partials/modals/companies/add_invoice_template";
import modal_edit_invoice_template from "partials/modals/companies/edit_invoice_template";

export default {
  name: "new_payment_process_information",
  components: {
    Multiselect,
    BootstrapToggle,
    modal_add_invoice_template,
    modal_edit_invoice_template
  },
  props: [
    'ifNotCompanyContactUser',
    'payment_process_info',
    'isPayrollCrm',
    'isRecruitmentCrm',
    'returnCrmCompanyName',
    'company'
  ],
  data() {
    return {
      e_payment_info_process: false,
      edit_payment_process_info: {},
      batch_types: [
        {ident: 'batched_by_vat', value: 'VAT'},
        {ident: 'batched_by_site', value: 'Site'},
        {ident: 'batched_by_po_number', value: 'PO Number'},
        {ident: 'batched_by_job_title', value: 'Job Title'},
      ],
      line_types: [
        {ident: 'list_by_worker', value: 'List by worker'},
        {ident: 'group_by_worker', value: 'Group by worker'},
        {ident: 'group_by_site', value: 'Group by site'}
      ],
      ms_opts: {
        gm_solution: this.$store.state.crm_options.payroll_client_solution,
        invoicing_type: [
          'vat - sites one line - plus additions',
          'vat - sites per line - plus additions',
          'vat - sites one line - extra additions',
          'vat - sites per line - extra additions',
          'vat - sites - plus additions',
          'vat - sites - extra additions',
          'sites'
        ],
        pay_cycle: this.$store.state.crm_options.pay_cycle,
        timesheet_cycle: this.$store.state.crm_options.timesheet_cycle,
        pay_week_start_day: daysOfWeek,
        pay_instruction_day: daysOfWeek,
        pay_client_payment_day: daysOfWeek,
        vat_perc_worked_to: this.$store.state.crm_options.vat_percentage
      },
      disable_min_vat: false,
    }
  },
  computed: {
    /**
     * Return formatted payroll solution for company
     * @returns {*|string}
     */
    return_payroll_solution() {
      return this.payment_process_info.payroll_solution_id !== null
          ? this.$store.state.crm_options.payroll_client_solution.find(p => p.id === this.payment_process_info.payroll_solution_id).value
          : "&nbsp;";
    },
    /**
     * Return formatted minimum VAT value worked to
     * @returns {null|string}
     */
    return_min_vat_worked_to() {
      return this.payment_process_info.min_vat_percentage_worked_to !== null
          ? this.payment_process_info.min_vat_percentage_worked_to
          : "&nbsp;";
    },
    /**
     * Return formatted value for if the company pay's into the trust account FOR GM
     * @returns {string}
     */
    return_pay_trust_account() {
      if (this.payment_process_info.pay_trust_account) {
        return "Yes"
      }
      else if (!this.payment_process_info.pay_trust_account) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * Does the company have a contractor template set up
     * @returns {boolean}
     */
    hasContractorInvoiceTemplate() {
      return this.company.invoice_settings.has_contractor_template
    },
    /**
     * Does the company have a PAYE template set up
     * @returns {boolean}
     */
    hasPayeInvoiceTemplate() {
      return this.company.invoice_settings.has_paye_template
    },
    /**
     * If a company has both contractor and paye templates hid the 'add invoice template' button
     * @returns {boolean}
     */
    showAddInvoiceTemplateButton() {
      return !(this.hasContractorInvoiceTemplate && this.hasPayeInvoiceTemplate);
    },
    /**
     * Return invoicing type
     * @returns {null|string}
     */
    return_invoicing_type() {
      return this.payment_process_info.invoicing_type !== null
          ? this.payment_process_info.invoicing_type
          : "&nbsp;";
    },
    /**
     * Return formatted payment cycle for the company (timesheet period)
     * @returns {*|string}
     */
    return_pay_cycle() {
      return this.payment_process_info.pay_cycle_id !== null
          ? this.$store.state.crm_options.pay_cycle.find(p => p.id === this.payment_process_info.pay_cycle_id).value
          : "&nbsp;";
    },
    /**
     * Return formatted timesheet cycle (how often a timesheet is submitted by the company)
     * @returns {*|string}
     */
    return_timesheet_cycle() {
      return this.payment_process_info.timesheet_cycle_id !== null
          ? this.$store.state.crm_options.timesheet_cycle.find(p => p.id === this.payment_process_info.timesheet_cycle_id).value
          : "&nbsp;";
    },
    /**
     * Return period start of the week day
     * @returns {null|string}
     */
    return_pay_week_start_day() {
      return this.payment_process_info.pay_week_start_day !== null
          ? this.payment_process_info.pay_week_start_day
          : "&nbsp;";
    },
    /**
     * Return day of the week that the instruction will be received by the crm company from the company submitting
     * @returns {null|string}
     */
    return_pay_instruction_day() {
      return this.payment_process_info.pay_instruction_day !== null
          ? this.payment_process_info.pay_instruction_day
          : "&nbsp;";
    },
    /**
     * Return day of the week that the company submitting will pay the crm company
     * @returns {null|string}
     */
    return_pay_client_payment_day() {
      return this.payment_process_info.pay_client_payment_day !== null
          ? this.payment_process_info.pay_client_payment_day
          : "&nbsp;";
    },
    /**
     * Return value for if PO's are required
     * @returns {string}
     */
    return_po_required() {
      if (this.payment_process_info.po_required) {
        return "Yes"
      }
      else if (!this.payment_process_info.po_required) {
        return "No"
      }
      else return "&nbsp;"
    },
    /* ---------------------------------------------------------------------------------------------------------
     * PAYROLL CRM
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * For payroll crm - If payment terms are required
     * @returns {boolean|*}
     */
    isPayrollRequirePaymentTerms() {
      return this.payment_process_info.payroll_require_payment_terms
    },
    /**
     * For payroll crm - Return value for payment terms required
     * @returns {string}
     */
    return_payroll_require_payment_terms() {
      if (this.payment_process_info.payroll_require_payment_terms) {
        return "Yes"
      }
      else if (!this.payment_process_info.payroll_require_payment_terms) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * For payroll crm - Return value of payment terms length
     * @returns {string}
     */
    return_payroll_payment_terms_length() {
      return this.payment_process_info.payroll_payment_terms_length !== null
          ? this.payment_process_info.payroll_payment_terms_length + " Day(s)"
          : "&nbsp;";
    },
    /**
     * For payroll crm - Return formatted payment terms percentage
     * @returns {string}
     */
    return_payroll_payment_terms_percentage() {
      if (this.payment_process_info.payroll_payment_terms_perc !== null) {
        return this.$options.filters.percentage(this.payment_process_info.payroll_payment_terms_perc)
      }
      else return "&nbsp;"
    },
    /* ---------------------------------------------------------------------------------------------------------
     * RECRUITMENT CRM
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * For recruitment crm - If payment terms are required
     * @returns {boolean|*}
     */
    isRecruitmentRequirePaymentTerms() {
      return this.payment_process_info.recruitment_require_payment_terms
    },
    /**
     * For recruitment crm - Return value for payment terms required
     * @returns {string}
     */
    return_recruitment_require_payment_terms() {
      if (this.payment_process_info.recruitment_require_payment_terms) {
        return "Yes"
      }
      else if (!this.payment_process_info.recruitment_require_payment_terms) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * For recruitment crm - Return value of payment terms length
     * @returns {string}
     */
    return_recruitment_payment_terms_length() {
      return this.payment_process_info.recruitment_payment_terms_length !== null
          ? this.payment_process_info.recruitment_payment_terms_length + " Day(s)"
          : "&nbsp;";
    },
    /**
     * For recruitment crm - Return formatted payment terms percentage
     * @returns {string}
     */
    return_recruitment_payment_terms_percentage() {
      if (this.payment_process_info.recruitment_payment_terms_perc !== null) {
        return this.$options.filters.percentage(this.payment_process_info.recruitment_payment_terms_perc)
      }
      else return "&nbsp;"
    },
  },
  methods: {
    /**
     * Switch vue to show form to edit payment process information
     * and set values on form
     */
    edit_form() {
      this.edit_payment_process_info = Object.assign({}, this.payment_process_info);
      // Format values for multiselect's from data loaded from record
      this.edit_payment_process_info['payroll_solution'] =
          this.$store.state.crm_options.payroll_client_solution.find(p => p.id === this.payment_process_info.payroll_solution_id);
      this.edit_payment_process_info.min_vat_percentage_worked_to =
          this.$store.state.crm_options.vat_percentage.find(vp => vp.value === this.edit_payment_process_info.min_vat_percentage_worked_to)
      this.edit_payment_process_info['pay_cycle'] =
          this.$store.state.crm_options.pay_cycle.find(p => p.id === this.payment_process_info.pay_cycle_id);
      this.edit_payment_process_info['timesheet_cycle'] =
          this.$store.state.crm_options.timesheet_cycle.find(p => p.id === this.payment_process_info.timesheet_cycle_id);
      // show form
      this.$nextTick(() => this.e_payment_info_process = true)
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_payment_process_info = {};
      this.e_payment_info_process = false;
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editPaymentInfoProcessForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editPaymentInfoProcessForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);
          let company_pay_promises = [];
          company_pay_promises.push(new Promise(resolve => {
            let submit_ppi = {
              company_id: this.company.id,
              payroll_solution_id: null,
              min_vat_percentage_worked_to: null,
              invoicing_type: this.edit_payment_process_info.invoicing_type,
              additional_invoice_requirements: this.edit_payment_process_info.additional_invoice_requirements,
              pay_cycle_id: null,
              timesheet_cycle_id: null,
              pay_week_start_day: this.edit_payment_process_info.pay_week_start_day,
              pay_instruction_day: this.edit_payment_process_info.pay_instruction_day,
              pay_client_payment_day: this.edit_payment_process_info.pay_client_payment_day,
              payroll_require_payment_terms: this.edit_payment_process_info.payroll_require_payment_terms,
              payroll_payment_terms_length: this.edit_payment_process_info.payroll_payment_terms_length,
              payroll_payment_terms_perc: this.edit_payment_process_info.payroll_payment_terms_perc,
              recruitment_require_payment_terms: this.edit_payment_process_info.recruitment_require_payment_terms,
              recruitment_payment_terms_length: this.edit_payment_process_info.recruitment_payment_terms_length,
              recruitment_payment_terms_perc: this.edit_payment_process_info.recruitment_payment_terms_perc,
              pay_trust_account: this.edit_payment_process_info.pay_trust_account,
              po_required: this.edit_payment_process_info.po_required,
              po_details: this.edit_payment_process_info.po_details,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            // if a payroll solution is selected format value to be saved to the database (id)
            if (this.edit_payment_process_info.payroll_solution !== null && this.edit_payment_process_info.payroll_solution !== undefined) {
              submit_ppi.payroll_solution_id = this.edit_payment_process_info.payroll_solution.id
            }
            // if a minimum VAT percentage worked to is selected format value to be saved to the database (value)
            if (this.edit_payment_process_info.min_vat_percentage_worked_to !== null && this.edit_payment_process_info.min_vat_percentage_worked_to !== undefined) {
              submit_ppi.min_vat_percentage_worked_to = this.edit_payment_process_info.min_vat_percentage_worked_to.value
            }
            // if a pay cycle is selected format value to be saved to the database (id)
            if (this.edit_payment_process_info.pay_cycle !== null && this.edit_payment_process_info.pay_cycle !== undefined) {
              submit_ppi.pay_cycle_id = this.edit_payment_process_info.pay_cycle.id
            }
            // if a timesheet cycle is selected format value to be saved to the database (id)
            if (this.edit_payment_process_info.timesheet_cycle !== null && this.edit_payment_process_info.timesheet_cycle !== undefined) {
              submit_ppi.timesheet_cycle_id = this.edit_payment_process_info.timesheet_cycle.id
            }
            // Save updates to database
            axios.patch(this.crmApiPath + 'company/payment_process_info/' + this.edit_payment_process_info.id, submit_ppi).then(() => resolve());
          }));
          // Once data has been saved reload vue and hide edit form
          Promise.all(company_pay_promises).then(() => {
            this.$bus.$emit('company_pre_agreement::reload', {action: true});
            this.$bus.$emit('company_payment_process::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // close form
            this.$nextTick(() => {
              this.e_payment_info_process = false;
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            })
          });
        }
      });
    },
    /* -----------------------------------------------------------------------------------------------
     * Invoice templates
     * -----------------------------------------------------------------------------------------------
     */
    /**
     * Return formatted value for batch type of the invoice template
     * @param template
     * @returns {*}
     */
    return_batch_type(template) {
      let batch_type = this.batch_types.find(type => type.ident === template.batch_type)
      return batch_type.value
    },
    /**
     * Return formatted value for line type of invoice template
     * @param template
     * @returns {*}
     */
    return_line_type(template) {
      let line_type = this.line_types.find(type => type.ident === template.line_type)
      return line_type.value
    },
    /**
     * Return string formatted value for if additions are applied on the template
     * @param template
     * @returns {string}
     */
    return_additions_inclusive(template) {
      return template.additions_inclusive ? 'Yes' : 'No';
    },
    /**
     * Return string formatted value for if margin is applied on the template
     * @param template
     * @returns {string}
     */
    return_margin_inclusive(template) {
      return template.margin_inclusive ? 'Yes' : 'No';
    },
    /**
     * Return string formatted value for if reverse VAT is applied on the template
     * @param template
     * @returns {string}
     */
    return_reverse_vat_applies(template) {
      return template.reverse_vat_applied ? 'Yes' : 'No';
    },
    return_created_last_updated_by(template) {
     let last_log = template.rel_company_logs[template.rel_company_logs.length - 1];
     if (last_log !== undefined) {
       let log_by = last_log.log_by.first_name + ' ' + last_log.log_by.surname,
           log_at = this.$options.filters.formatDateTime(last_log.updated_at)
       return log_by + ' on ' + log_at
     }
     else {
       return ''
     }

    },
    add_invoice_template() {
      this.$store.commit('SHOW_ADD_EDIT_INVOICE_TEMPLATE_MODAL', {
        add: true,
        edit: false,
        company_name: this.company.company_name,
        company_id: this.company.id,
        template: {},
        hasContractorInvoiceTemplate: this.hasContractorInvoiceTemplate,
        hasPayeInvoiceTemplate: this.hasPayeInvoiceTemplate
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_invoice_template'));

    },
    edit_invoice_template() {
      let template = {}
      // set template to pass to edit modal
      if (this.hasContractorInvoiceTemplate) {
        template = this.company.invoice_settings.templates.find(template => {
          return template.invoice_template === 'CONTRACTOR'
        })
      }
      if (this.hasPayeInvoiceTemplate) {
        template = this.company.invoice_settings.templates.find(template => {
          return template.invoice_template === 'PAYE'
        })
      }
      this.$store.commit('SHOW_ADD_EDIT_INVOICE_TEMPLATE_MODAL', {
        add: false,
        edit: true,
        company_name: this.company.company_name,
        company_id: this.company.id,
        template: template,
        hasContractorInvoiceTemplate: this.hasContractorInvoiceTemplate,
        hasPayeInvoiceTemplate: this.hasPayeInvoiceTemplate
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_invoice_template'));
    },
    delete_invoice_template(template) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm invoice template deletion</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you want to delete the<br>' +
            '<strong>' + template.invoice_template + ' invoice template</strong><br>' +
            'for ' + this.company.company_name +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Delete', action: (toast) => {
              axios.delete(this.crmApiPath + 'company/invoice_settings/' + template.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$bus.$emit('company::reload', {action: true})
                this.$bus.$emit('logs::reload', {action: true})
                this.$snotify.remove(toast.id)
              })
            }

          },
          {
            text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)
          },
        ]
      });
    },
    /* -----------------------------------------------------------------------------------------------
     * edit information on template
     * -----------------------------------------------------------------------------------------------
     */
    /**
     * Action to take when the payroll solution is changed for the company
     * @param val
     */
    select_payroll_solution(val) {
      // if the payroll solution is 'standard'
      if (val !== null && val.value === 'Standard Payroll') {
        // set the minimum VAT worked to option's to only include 20% and set the multiselect selection to 20%
        this.ms_opts.vat_perc_worked_to = [{id: 14, value: '20%'}];
        this.edit_payment_process_info.min_vat_percentage_worked_to = {id: 14, value: '20%'}
        // disable the minimum VAT worked to multiselect so that the user can not change it
        this.disable_min_vat = true;
      }
      else {
        // set minimum VAT worked to option's back to default
        this.ms_opts.vat_perc_worked_to = this.$store.state.crm_options.vat_percentage
        // enable the minimum VAT worked to multiselect so a percentage can be selected by the user
        this.disable_min_vat = false;
      }
    },
  },
  watch: {
    'edit_payment_process_info.payroll_require_payment_terms'(val) {
      if (!val) {
        this.edit_payment_process_info.payroll_payment_terms_length = ''
        this.edit_payment_process_info.payroll_payment_terms_perc = ''
      }
    },
    'edit_payment_process_info.recruitment_require_payment_terms'(val) {
      if (!val) {
        this.edit_payment_process_info.recruitment_payment_terms_length = ''
        this.edit_payment_process_info.recruitment_payment_terms_perc = ''
      }
    },
    'edit_payment_process_info.po_required'(val) {
      if (!val) {
        this.edit_payment_process_info.po_details = ''
      }
    }
  }
}
</script>

<style lang="scss">
.payment_process_info {
  .table {
    td {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }
}
</style>

<style scoped lang="scss">
pre {
  padding-top:   12px;
  margin-bottom: 0;
  font-family:   $font-family-header;
  font-size:     0.75rem;
  font-weight:   400;
  line-height:   1.6;
}
.template_card {
  .template_label {
    display: inline-block;
    width: 150px;
  }
}
</style>
